/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Overwrite_ConfirmInputs */

const en_explorer_table_overwrite_confirm = /** @type {(inputs: Explorer_Table_Overwrite_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overwrite`)
};

const fr_explorer_table_overwrite_confirm = /** @type {(inputs: Explorer_Table_Overwrite_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ecraser`)
};

const de_explorer_table_overwrite_confirm = /** @type {(inputs: Explorer_Table_Overwrite_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überschreiben`)
};

const it_explorer_table_overwrite_confirm = /** @type {(inputs: Explorer_Table_Overwrite_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovrascrivi`)
};

const ru_explorer_table_overwrite_confirm = /** @type {(inputs: Explorer_Table_Overwrite_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перезаписать`)
};

const es_explorer_table_overwrite_confirm = /** @type {(inputs: Explorer_Table_Overwrite_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exagerar`)
};

const zh_cn2_explorer_table_overwrite_confirm = /** @type {(inputs: Explorer_Table_Overwrite_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`覆盖`)
};

const ja_explorer_table_overwrite_confirm = /** @type {(inputs: Explorer_Table_Overwrite_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上書き`)
};

const hi_explorer_table_overwrite_confirm = /** @type {(inputs: Explorer_Table_Overwrite_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओवरराइट`)
};

const pt_pt2_explorer_table_overwrite_confirm = /** @type {(inputs: Explorer_Table_Overwrite_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobrescrever`)
};

/**
* | output |
* | --- |
* | "Overwrite" |
*
* @param {Explorer_Table_Overwrite_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_overwrite_confirm = /** @type {((inputs?: Explorer_Table_Overwrite_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Overwrite_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_table_overwrite_confirm(inputs)
	if (locale === "de") return de_explorer_table_overwrite_confirm(inputs)
	if (locale === "it") return it_explorer_table_overwrite_confirm(inputs)
	if (locale === "ru") return ru_explorer_table_overwrite_confirm(inputs)
	if (locale === "es") return es_explorer_table_overwrite_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_table_overwrite_confirm(inputs)
	if (locale === "ja") return ja_explorer_table_overwrite_confirm(inputs)
	if (locale === "hi") return hi_explorer_table_overwrite_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_table_overwrite_confirm(inputs)
	return en_explorer_table_overwrite_confirm(inputs)
});